import { createContext, useContext } from "react";

import type { Persona } from "./types";

interface PersonaContextValue {
  persona: Persona;
  onPersonaChange: (persona: Persona) => void;
}

export const PersonaContext = createContext<PersonaContextValue>({
  persona: "backoffice",
  onPersonaChange: () => {},
});

export function usePersona() {
  return useContext(PersonaContext);
}
